<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13zFgid/images/9780825475092_cover.jpg?1685327175181" alt="This image is the cover for the book Marriage Off Course"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marriage Off Course
      </h1>
      <p class="bookDescription body article font2">
        <b>What to do when your partner is done</b><br/><br/>"My spouse left and I don’t know what to do."<br/>"This pain won't go away; what's wrong with me?"<br/>"How can I save my marriage?"<br/><br/>These are common questions from hurting spouses encountering unwanted separation. When you're the only one who wants to save your marriage, what do you do?<br/><br/>Clint and Penny Bragg have experienced the excruciating pain of separation firsthand. They also have a decade of helping hundreds of other hurting spouses. From the lessons they've learned, the Braggs have crafted this guide to navigating marital strife, separation, or divorce, showing readers what to do when your spouse is done with the marriage--and what not to do.<br/><br/>Wise counsel, support, and hope that the marriage can be saved are critical. Equally important is learning to seek God and deepen your faith in Him. The Braggs share candid stories from others who have experienced the desert of broken marriages as well as applicable stories from the Bible. Helpful charts, lists, and diagrams, and QR codes linking readers to audio prayers, provide even more personal interaction.<br/><br/>With innovative tools, deep empathy and understanding, and a biblical basis for all their advice, <i>Marriage Off Course</i> contains a wealth of help and the ultimate message: there is hope--and there is help.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clint Bragg, Peggy A. Bragg
      </h2>
      
      <p class="authorDescription body article">Clint and Penny A. Bragg serve as marriage missionaries through the work of Inverse Ministries, their nonprofit organization. They share their testimony with audiences, teach seminars for couples, and equip ministry leaders. Their own story of reconciliation has been featured on multiple national and international television and radio programs. The Braggs are an active part of a countrywide network to strengthen, reconcile, and restore marriages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kregel Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ed5b986